import {ChangeDetectionStrategy, Component, inject, ViewChild, TemplateRef} from '@angular/core';
import {
    TuiButton,
    type TuiDialogContext,
    TuiDialogService,
    type TuiDialogSize,
} from '@taiga-ui/core';
import {type PolymorpheusContent} from '@taiga-ui/polymorpheus';

@Component({
    selector: 'app-plan-details',
    standalone: true,
    imports: [TuiButton],
    templateUrl: './plan-details.html',
    styleUrls: ['./plan-details.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanDetailsComponent {
    private readonly dialogs = inject(TuiDialogService);

    @ViewChild('content', { static: true })
    protected readonly content!: TemplateRef<TuiDialogContext>;

    @ViewChild('header', { static: true })
    protected readonly header!: TemplateRef<any>;

    public openPlanDetailsDialog(): void {
        this.onClick(this.content, this.header, 'fullscreen');
    }

    protected onClick(
        content: PolymorpheusContent<TuiDialogContext>,
        header: PolymorpheusContent,
        size: TuiDialogSize,
    ): void {
        this.dialogs
            .open(content, {
                label: '',
                header,
                size,
            })
            .subscribe();
    }
}
